import type { InnogyComponentRendering } from '@core/jss-models';
import type { ActionReducerMap } from '@ngrx/store';
import type { Actions } from 'ngrx-forms';

import type { OrderAddressState } from './address';
import { orderAddressReducer } from './address';
import type { OrderConfirmationState } from './confirmation';
import { orderConfirmationReducer } from './confirmation';
import type { OrderPaymentState } from './payment';
import { orderPaymentReducer } from './payment';
import type { OrderPersonalState } from './personal';
import { orderPersonalReducer } from './personal';
import type { OrderCrossSellState } from './cross-sell';
import { orderCrossSellReducer } from './cross-sell';
import type { OrderCustomerTypeState } from './customer-type';
import { orderCustomerTypeReducer } from './customer-type';

export const OrderReducers: ActionReducerMap<OrderState, Actions<unknown>> = {
  orderPersonalForm: orderPersonalReducer,
  orderPaymentForm: orderPaymentReducer,
  orderAddressForm: orderAddressReducer,
  orderConfirmationForm: orderConfirmationReducer,
  orderCrossSellForm: orderCrossSellReducer,
  orderCustomerType: orderCustomerTypeReducer,
};

export interface OrderState {
  readonly orderPersonalForm: OrderPersonalState;
  readonly orderPaymentForm: OrderPaymentState;
  readonly orderAddressForm: OrderAddressState;
  readonly orderConfirmationForm: OrderConfirmationState;
  readonly orderCrossSellForm: OrderCrossSellState;
  readonly orderCustomerType: OrderCustomerTypeState;
  readonly rendering?: InnogyComponentRendering | any;
}
